import type { ICGG2Report } from '@fortem-monorepo/web-sdk'

/** Convert backend values into the units used by the entered limits. */
export const getGuidelineValueScale = (
  guideline: Pick<ICGG2Report.GuidelineResult['guideline'], 'table' | 'value_column' | 'threshold_type'>,
  row: Record<string, unknown>,
  valueUnit?: 'unit' | 'percent' | 'basis_points' | null,
) => {
  if (valueUnit != null) {
    const sourceScale = { unit: 1, percent: 100, basis_points: 10_000 }[valueUnit]
    const thresholdScale = guideline.threshold_type === 'percentage' ? 100 : guideline.threshold_type === 'basis_points' ? 10_000 : 1
    return thresholdScale / sourceScale
  }
  return guideline.table === 'summary.headline' &&
  guideline.value_column === 'value' &&
  guideline.threshold_type === 'percentage' &&
  row.unit === 'pct'
    ? 100
    : 1
}

/** Plot evaluated values in the same units as the saved threshold labels. */
export const getGuidelineIndicatorValues = (
  guideline: Parameters<typeof getGuidelineValueScale>[0],
  rows: ICGG2Report.GuidelineEvaluatedRow[],
  aggregate: ICGG2Report.GuidelineAggregateEvaluation | null,
  valueUnit?: 'unit' | 'percent' | 'basis_points' | null,
): number[] => {
  const values = rows.flatMap(({ row, result }) =>
    result?.value === null || result?.value === undefined
      ? []
      : [result.value * getGuidelineValueScale(guideline, row, valueUnit)],
  )

  if (aggregate?.result.value !== null && aggregate?.result.value !== undefined) {
    values.push(aggregate.result.value * getGuidelineValueScale(guideline, rows[0]?.row ?? {}, valueUnit))
  }

  return values
}
